export default "__VITE_ASSET__ChrcY5Lo__"